/* eslint-disable max-lines */
import {
    drpRequest,
    goodsBasicRequest,
    goodsRequest,
    marketRequest,
    openGoodsRequest,
    securityRequest
} from '@/utils/request'

import {
    AbnormalPriceSpuVo,
    AsyncQueryDisErpGoodsDataUsingGetParams,
    BatchCreateGoodsMatchParam,
    BatchUpsertGoodsSortVo,
    BindLinkParam,
    BuyerAdditionalSkuQueryVo,
    BuyerSkuAdditionalVo,
    BuyerSkuVo,
    BuyerSpuVo,
    BuyerSupplierGoodsQuery1,
    BuyerSupplierGoodsQueryForMall,
    BuyerSupplierSkuQueryParam,
    CannotShelvesShopParam,
    CannotShelvesShopResult,
    CannotShelvesShopResultV2,
    CanUseStockVo,
    CardDetailResult,
    CategoryForecastPlatformParam,
    CategoryForecastPlatformResult,
    CategoryForecastWithNameAndMainImageParam,
    CategoryForecastWithNameAndMainImageResult,
    CateMaxLength,
    ChangeCheckSyncParam,
    CheckLimitShelvesPlatformParam,
    CheckShowErpSkuStatusUsingGetParams,
    CheckSkuIfShowUsingGet1Params,
    CheckSkuIfShowUsingGet2Params,
    CheckStyleCodeExist,
    CheckUpdateStatusParam,
    CheckUpdateStatusResultVo,
    CloudDiskLink,
    CloudDiskTextVO,
    CoIdAndSpuId,
    CommonUsedSpecVo,
    CopyGoodsVo,
    DeleteShopItemParamData,
    DeleteShopItemVo,
    DeleteTemplateVo,
    DisErpGoodsQuery,
    DisGoodsInfo,
    DistributionMyselfSkuListResultVo,
    ErpComprehensiveSku,
    ErpDisSku,
    ErpItemAddParam,
    ErpItemQueryResult,
    ErpItemSpuInfo,
    ErpResult,
    ErpSupplySalesGoodsFavoriteParam,
    ExcelImportStatus,
    ExcelTipsInfo,
    ExportDrpItemParam,
    ExportSkuParam,
    FillGoodsCategoryPropParam,
    ForecastCategoryResp,
    ForecastPreListQueryParam,
    ForecastPreListVo,
    FreshmanRefreshStatusVo,
    FreshmanSpuIdVo,
    GetCopyProcessUsingGetParams,
    GetErpItemCodeListByPartnerSpuIdUsingGetParams,
    GetExportProcessUsingGetParams,
    GetGoodsBySpuIdUsingGetParams,
    GetProcessUsingGet5Params,
    GoBranchShop,
    GoComboTempGoods,
    GoGoodsSearchKeywordVo,
    GoodsDetailVo,
    GoodsListUsingGet1Params,
    GoodsRepeatRecordResult,
    GoodsRequiredFieldConfigResult,
    GoodsRuleLimitItemQueryResult,
    GoodsRuleLimitItemQueryVo,
    GoTemplateLog,
    GylGoodsItemSpu,
    GylGoodsItemSpu1,
    HaveAlibabaImportTemplateUsingGetParams,
    ImageHandlerParam,
    ImageHandlerResult,
    ImageToOssResult,
    ImageToOssVo,
    InnerOpenCacheVo,
    ItemCode,
    ItemSpuShelvesVo,
    LimitShelvesPlatformsParam,
    ListCatOptionsUsingGetParams,
    ListSupplierBrandUsingGetParams,
    ListUsingGet4Params,
    MallTopGoodsParam,
    MallTopGoodsVo,
    ModifyPhotoParam,
    MoveTopSortVo,
    NeedSyncShopUsingGetParams,
    NotPerfectGoodsInfo,
    OnlineItemShelvesInfoParam,
    PddShelvesAuthorizationParam,
    PresaleMarkVo,
    PreShelvesGoodsInfoParam,
    QueryCanImproveWithAiCountUsingGetParams,
    QueryErpComprehensiveSkuParam,
    QueryErpItemParam,
    QueryExcludeReasonListUsingGetParams,
    QueryExportDataUsingGetParams,
    QueryGoodsDetail,
    QueryHaveCleanFlagItemUsingGetParams,
    QueryItemCleanEnabledUsingGetParams,
    QueryItemSourceInfoUsingGetParams,
    QueryLastTimeShelvesDetailResult,
    QueryLastTimeShelvesDetailResultV2,
    QueryLastTimeShelvesDetailUsingGetParams,
    QueryLastTimeShelvesDetailV2UsingGetParams,
    QueryMainProductChannelTotalUsingGetParams,
    QueryOneRepeatCacheListParam,
    QueryPlatformUseShopUsingGetParams,
    QueryPresaleMarkParam,
    QueryRepeatCacheListParam,
    QueryReportGoodsDetailUsingGetParams,
    QuerySearchKeywordUsingGet1Params,
    QueryShelvesParam,
    QueryShopItemLimitVo,
    QueryShopItemTotalAndLimitUsingGetParams,
    QuerySpecBySpecNameUsingGetParams,
    QuerySupplierBrandUsingGetParams,
    QuerySupplySalesGoodsFavoriteResult,
    RepeatCacheBatchMergeParam,
    RepeatCacheBatchParam,
    ReportMsgVo,
    SelectPageUsingGetParams,
    SelectShopAddressUsingGetParams,
    SensitiveWords,
    SensitiveWordsCheckVo,
    SensitiveWordsDeleteVo,
    SensitiveWordsInsertVo,
    SensitiveWordsQuery,
    SensitiveWordsUpdateVo,
    ShelvesErpSupplier,
    ShelvesSuccessRate,
    ShopAddress,
    ShopDetailParamVo,
    ShopItem,
    ShopItemSpuVo,
    ShopManageAfterSaleSpuQuery,
    ShopSpuItem,
    ShopSpuItemParam,
    SimpleUserCatVo,
    SkuCopyResult,
    SkuCopyToErp,
    SkuDetailInfoVo,
    SkuExportResult,
    SkuListUsingGetParams,
    SpuIdAndStyleCode,
    SpuRegulatePriceInterceptVo,
    StartPlatformForecastParam,
    StockConfigVo,
    StyleCodeVo,
    SupplierChangeSyncResp,
    SyncAfterSaveGoodsParam,
    TaskStatusInfoVo,
    UpdateGoodsResult,
    UpdateGoodsSortVo,
    UpdatePlatformData,
    UpdateShopOnlineItemData,
    UpdateShopStockVo,
    UpdateSkuPriceParam,
    UpdateStockParam,
    UpsertSpuVo,
    SupplierDrpGoodsReturnGoodsAddressVo,
    VideoVo,
    ImageZoomParam,
    ErpItemCodeVo,
    StartPlatformImproveParam,
    ForecastQuotaResp,
    QueryTaskUsingGet4Params,
    QueryAiPlatFormInfoVo,
    QueryForecastShopIdParam,
    CancelPlatformImproveParam,
    NoticeTypeList,
    QueryNoticeResult,
    QueryNoticeStatusParam,
    NoticeStatus,
    SimpleSpuInfoVo
} from '@servicesTypings/goodsRequestV3'

import {
    BigShopAllowViewStock,
    ErpOfflineSupplierVo,
    FindCoopSupplierStatusVo,
    FindGoodsConfigVo,
    GetPartnerDisLevelUsingGet1Params,
    GetShowErpGoodsTabUsingGetParams,
    HotSellConfigVo,
    ListAllSupplierOfflineUsingGetParams,
    ListMySupplierUsingGetParams,
    MySupplierListVo,
    QueryInFreshmanCategoryResult,
    QueryInFreshmanCategoryUsingGetParams
} from '@servicesTypings/drpRequest'
import {
    GoodsFreshmanLabelVo,
    QueryTileLabelsUsingGetParams,
    SellWellSortWeightVo
} from '@servicesTypings/marketRequest'

import { getCacheService, postCacheService } from '@/utils/requestUtils'
import { v4 as uuidv4 } from 'uuid'
import * as Sentry from '@sentry/browser'

import {
    AiForecastStatisticsVo,
    ListUsingGetParams,
    GoGoodsConfigLog,
    DetailUsingGetParams
} from '@servicesTypings/goodsBasicRequest'

import {
    ShopLinkExportParam,
    RedisProgressInfo,
    ProfitCalcInfoVo,
    ShopLinkProfitStatisticsResult,
    ShopLinkQueryParam,
    ShopLinkQueryResult,
    QueryExportData1Params,
    ProfitConfigVo,
    SelectedUpdateOnlinePriceVo,
    AllShopLinkUpdateOnlinePriceVo,
    QuerySimpleSpuListParam,
    AfterSaleAddressSupplierHierarchyVo
} from '@servicesTypings/goodsRequestV3'

/**
 * 提报商品
 */
export function createGoods(data: UpsertSpuVo): API.Res<string> {
    return goodsRequest.post('/supplier/goods/addGoods', { data })
}

/**
 * 查询分销小站异常基本售价商品ID(前100个商品的ID)
 */
/**
 * 查询分销小站异常基本售价商品数量及前100个商品ID
 */
export function queryAbnormalPriceSpuIdList(): API.Res<AbnormalPriceSpuVo> {
    return goodsRequest.get('/buyer/supplier/abnormalPriceSpuIdList')
}

/**
 *线下合作商家商品列表
 */
/**
 * 查询线下供应商商品列表
 */
export function querySupplierGoodsListOffline(params: GoodsListUsingGet1Params): API.Res<BuyerSpuVo[]> {
    return goodsRequest.get('/buyer/supplier/offline/pc/goods/list', { params })
}

/**
 * 新供应链商品详情
 */
/**
 * 查询商品详情
 */
export function queryGoodsDetail(data: QueryGoodsDetail): API.Res<GoodsDetailVo> {
    return goodsRequest.post('/goods/queryGoodsDetail', { data })
}

/**
 * 新供应链商品详情（open）
 */
/**
 * 查询商品详情
 */
export function queryGoodsDetailOpen(data: QueryGoodsDetail): API.Res<GoodsDetailVo> {
    return openGoodsRequest.post('/open/supplier/goods/queryGoodsDetail', { data })
}

/**
 * 新供应链商品详情(商品管理-自营商品)
 */
/**
 * 查询自己商品信息详情
 */
export function queryMySelfGoodsDetail(data: QueryGoodsDetail): API.Res<GoodsDetailVo> {
    return goodsRequest.post('/myself/goods/queryGoodsDetail', { data })
}

// 商品资料：查询商品信息
/**
 * 根据商品id查询商品
 */
export function queryGoodsBySpuId(params: GetGoodsBySpuIdUsingGetParams): API.Res<GylGoodsItemSpu> {
    return goodsRequest.get('/supplier/goods/getGoodsBySpuId', { params })
}

// 查询拼款临时商品
/**
 * 新增、查询拼款临时商品
 */
export function listGoComboTempGoods(): API.Res<GoComboTempGoods[]> {
    return goodsRequest.get('/goods/goComboTempGoods/listGoComboTempGoods')
}

// 供应链商品服务接口说明
/**
 * 删除拼款临时商品
 */
export function deleteComboTempGoods(data: string[]): API.Res<object> {
    return goodsRequest.post('/goods/goComboTempGoods/deleteComboTempGoods', { data })
}

// 供应链商品服务接口说明
/**
 * 查询拼款临时商品数量
 */
export function queryCountComboTempGoods(): API.Res<number> {
    return goodsRequest.get('/goods/goComboTempGoods/countComboTempGoods')
}

/*
 *  商品资料：查询商品信息 缓存
 *  首次直接调用，返回key, 第二次调用可以用key调用缓存数据
 **/
const cacheBaseGoods = {}

export function queryCacheGoodsBySpuId(params, key = new Date().getTime()) {
    if (!cacheBaseGoods[key]) {
        goodsRequest
            .get('/supplier/goods/getGoodsBySpuId', {
                params
            })
            .then(json => {
                cacheBaseGoods[key] = { ...json, state: 'complete' }
            })
        cacheBaseGoods[key] = { state: 'done' }
        return key
    } else {
        const intervalTime = 30
        return new Promise(resolve => {
            const getGoods = setInterval(() => {
                if (cacheBaseGoods[key]?.state === 'complete') {
                    resolve(cacheBaseGoods[key])
                    cacheBaseGoods[key] = null
                    clearInterval(getGoods)
                }
            }, intervalTime)
        })
    }
}

// 供销商品管理：查询商品信息
/**
 * 根据商品ID查询SKU列表
 */
export function getSkuList(params: SkuListUsingGetParams): API.Res<DistributionMyselfSkuListResultVo> {
    return goodsRequest.get('/myself/distribution/goods/skuList', { params })
}

// 查询商家库存配置
/**
 * 查询商家库存配置
 */
export function queryStockConfig(): API.Res<StockConfigVo> {
    return goodsRequest.get('/goods/stock/queryStockConfig')
}

// 修改库存
/**
 * 修改库存
 */
export function updateStock(data: UpdateStockParam): API.Res<object> {
    return goodsRequest.post('/goods/stock/updateStock', { data })
}

// 修改库存
/**
 * 修改sku的基本售价和1-5级供货价
 */
export function updateSkuListPrice(data: UpdateSkuPriceParam[]): API.Res<object> {
    return goodsRequest.post('/myself/distribution/goods/updateSkuListPrice', { data })
}

// 修改库存
/**
 * 查询多个SKU同步ERP价格说明
 */
export function querySkuListUpdateErpPriceTask(data: UpdateSkuPriceParam[]): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/myself/distribution/goods/querySkuListUpdateErpPriceTask', { data })
}

// 商品资料：更新
/**
 * 编辑商品
 */
export function updateGoods(data: UpsertSpuVo): API.Res<UpdateGoodsResult> {
    return goodsRequest.post('/supplier/goods/updateGoods', { data })
}

// 商品资料：查询导入商品信息
/**
 * swagger找不到此接口
 */
export function queryImportGoodsBySpuId(params) {
    return goodsRequest.get('/gylSupplierOnlineShopImportDetail/queryItemDetail', {
        params
    })
}

// 商品资料：更新导入商品状态
/**
 * swagger找不到此接口
 */
export function updateImportDetail(data) {
    return goodsRequest.post('/gylSupplierOnlineShopImportDetail/updateImportDetail', {
        data
    })
}

// 商品资料：获取所属供应商列表
/**
 * 所属供应商列表-下拉框
 */
export function queryOfflineSupplier(params: ListAllSupplierOfflineUsingGetParams): API.Res<ErpOfflineSupplierVo[]> {
    return drpRequest.get('/supplier/offline/listAllSupplierOffline', { params })
}

// 商品资料：查询ERP价格变更记录
/**
 * 查询单个SPU同步ERP价格说明
 */
export function querySpuUpdateErpPriceTask(data: GylGoodsItemSpu1): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/supplier/goods/querySpuUpdateErpPriceTask', { data })
}

// 规格图同步基础资料
/**
 * 查询修改图片提示信息
 */
export function queryModifyImageTask(data: ModifyPhotoParam): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/supplier/goods/queryModifyImageTask', { data })
}

/**
 * 新供应链商家商品列表Open
 */
export function querySupplierGoodsListOpen(params) {
    const goodsRequestCache = getCacheService(openGoodsRequest)
    return goodsRequestCache.get('/open/supplier/goods/pc/list', {
        params
    })
}

/**
 * 查询自定义类目下拉列表
 */
/**
 * 查询自定义类目下拉列表
 */
export function listCatOptions(params: ListCatOptionsUsingGetParams): API.Res<SimpleUserCatVo[]> {
    return goodsRequest.get('/goods/goUserCategory/listCatOptions', { params })
}

//  解析网盘链接
/**
 * 解析多个网盘链接
 */
export function parseDiskLink(data: CloudDiskTextVO): API.Res<CloudDiskLink[]> {
    return goodsRequest.post('/supplier/goods/parseDiskLink', { data })
}

// 根据spuIds查询款号
/**
 * 根据商品ID列表查询款号列表
 */
export function queryStyleCodeById(data: string): API.Res<string[]> {
    return goodsRequest.post('/goods/queryStyleCodeListBySpuIdList', { data })
}

// 校验该款式编码是否在ERP存在SKU (手工新增SKU使用)
/**
 * 校验该款式编码是否在ERP存在SKU
 */
export function checkErpHasSku(data: ErpItemAddParam): API.Res<ErpItemQueryResult> {
    return goodsRequest.post('/erp/goods/checkErpHasSku', { data })
}

// 根据款号获取并解析ERP商品信息
/**
 * 根据款号获取并解析ERP商品信息
 */
export function getErpItemInfo(data: ErpItemAddParam): API.Res<ErpItemSpuInfo> {
    return goodsRequest.post('/erp/goods/getErpItemInfo', { data })
}

// 校验该款式编码是否在供应链存在
/**
 * 查询款号是否存在
 */
export function queryStyleCodeExist(data: StyleCodeVo): API.Res<CheckStyleCodeExist> {
    return goodsRequest.post('/supplier/goods/queryStyleCodeExistV2', { data })
}

// 查询商家是否使用ERP管理库存
/**
 * 查询商家库存配置
 */
export function queryErpManageStock(): API.Res<StockConfigVo> {
    return goodsRequest.get('/goods/stock/queryStockConfig')
}

// 查询商品必填字段配置
/**
 * 查询商品必填字段配置
 */
export function queryGoodsRequiredFieldConfig(): API.Res<GoodsRequiredFieldConfigResult> {
    return goodsRequest.get('/goods/queryGoodsRequiredFieldConfig')
}

// 查询商品哪些平台有资料
/**
 * 查询商品已存在的平台资料
 */
export function queryPlatformDataExist(data: UpdatePlatformData): API.Res<string[]> {
    return goodsRequest.post('/goods/platform/queryPlatformDataExist', { data })
}

// 修改平台资料主图
/**
 * 商品保存后修改平台资料信息
 */
export function updatePlatformAfterSave(data: UpdatePlatformData): API.Res<object> {
    return goodsRequest.post('/goods/platform/updatePlatformAfterSave', { data })
}

// 检测商品编码是否在ERP
/**
 * 查询ERP不存在的商品编码
 */
export function queryNotExistErpItemCode(data: string[]): API.Res<string[]> {
    return goodsRequest.post('/supplier/goods/queryNotExistErpItemCode', { data })
}

// 检测商品是否加入分销小站
/**
 * 返回在小站里存在的商品编码
 */
export function querySkuDistributionLowerCase(data: string[]): API.Res<string[]> {
    return goodsRequest.post('/goodsQuery/querySkuDistributionLowerCase', { data })
}

/**
 * 展架详情查询商品来源信息（渠道）
 */
/**
 * 查询分销商品来源信息
 */
export function queryItemSourceInfo(params: QueryItemSourceInfoUsingGetParams): API.Res<DisGoodsInfo[]> {
    return goodsRequest.get('/buyer/supplier/queryItemSourceInfo', { params })
}

/**
 * 获取显示ERP商品TAB
 */
/**
 * 获取显示ERP商品TAB
 */
export function getShowErpGoodsTab(params: GetShowErpGoodsTabUsingGetParams): API.Res<boolean> {
    return drpRequest.get('/config/getShowErpGoodsTab', { params })
}

/**
 * 展架详情查询ERP来源商品（渠道）
 * ps：该接口未使用，待线上稳定可删除
 */
/**
 * swagger找不到此接口
 */
export function queryDisErpGoods(data) {
    return goodsRequest.post('/buyer/supplier/queryDisErpGoods', {
        data
    })
}

/**
 * 供应侧查询ERP来源商品 searchType
 */
/**
 * 查询供应商ERP分销商品数据
 */
export function queryDisErpGoodsDataV2(data: DisErpGoodsQuery): API.Res<ErpDisSku[]> {
    return goodsRequest.post('/buyer/supplier/queryDisErpGoodsDataV2', { data })
}

/**
 * 我的收藏 ERP来源商品
 */
/**
 * 查询供销商品收藏列表
 */
export function queryErpSupplySalesGoodsFavorite(
    data: ErpSupplySalesGoodsFavoriteParam
): API.Res<QuerySupplySalesGoodsFavoriteResult[]> {
    return goodsRequest.post('/channel/erpSupplySalesGoodsFavorite/querySupplySalesGoodsFavoriteList', { data })
}

//

/**
 * 铺供应商ERP商品获取缓存商品ID（渠道）
 */
/**
 * 铺供应商ERP商品获取缓存商品ID
 */
export function getErpListCacheSpuId(data: ShelvesErpSupplier): API.Res<CoIdAndSpuId> {
    return goodsRequest.post('/erpDirectShelves/erpSuppler/getCacheSpuId', { data })
}

/**
 * 铺货组合装商品获取商品ID
 */
/**
 * 组合装铺货获取缓存商品ID
 */
export function getCombineCacheSpuId(data: ItemCode): API.Res<CoIdAndSpuId> {
    return goodsRequest.post('/combinedGoods/getCombineCacheSpuId', { data })
}

// 查询常用规格
/**
 * 根据规格名查询常用规格
 */
export function queryCommonUsedSpecValue(params: QuerySpecBySpecNameUsingGetParams): API.Res<CommonUsedSpecVo> {
    return goodsRequest.get('/goCommonUsedSpec/querySpecBySpecName', { params })
}

// 编辑常用规格
/**
 * 修改常用规格
 */
export function editCommonUsedSpec(data: CommonUsedSpecVo): API.Res<CommonUsedSpecVo> {
    return goodsRequest.post('/goCommonUsedSpec/editCommonUsedSpec', { data })
}

// 新增常用规格
/**
 * 新增常用规格
 */
export function insertCommonUsedSpec(data: CommonUsedSpecVo): API.Res<CommonUsedSpecVo> {
    return goodsRequest.post('/goCommonUsedSpec/insertCommonUsedSpec', { data })
}

// 供应商库存列表导出
/**
 * 供应商库存列表导出
 */
export function exportDrpGoodsApi(data: ExportDrpItemParam): API.Res<SkuExportResult> {
    return goodsRequest.post('/buyer/supplier/exportDrpGoodsV2', { data })
}

// 更新商品置顶排序
/**
 * 单个商品置顶/取消置顶
 */
export function updateGoodsSort(data: UpdateGoodsSortVo): API.Res<object> {
    return goodsRequest.post('/mall/goodsTop/upsertGoodsSort', { data })
}

// 商品批量置顶-取消置顶
/**
 * 商品批量置顶/取消置顶
 */
export function batchUpsertGoodsSort(data: BatchUpsertGoodsSortVo): API.Res<object> {
    return goodsRequest.post('/mall/goodsTop/batchUpsertGoodsSort', { data })
}

// 复制商品到erp
/**
 * 供应商库存列表复制商品至ERP
 */
export function copyDrpGoodsToErp(data: SkuCopyToErp): API.Res<SkuCopyResult> {
    return goodsRequest.post('/buyer/supplier/copyDrpGoodsToErpV2', { data })
}

// 查询商家是否开启复制商品使用基本售价为成本价
/**
 * 查询商家是否开启复制商品使用基本售价为成本价
 */
export function queryCopyDrpPriceApi(): API.Res<boolean> {
    return goodsRequest.get('/buyer/supplier/queryCopyDrpPrice')
}

// 更新线上店铺库存
/**
 * 更新线上店铺库存
 */
export function updateShopStockApi(data: UpdateShopStockVo): API.Res<object> {
    return goodsRequest.post('/buyer/supplier/updateShopStock', { data })
}

// 通过规则 更新线上店铺库存
/**
 * 更新线上店铺库存-按同步规则
 */
export function updateShopStockByRuleApi(data: UpdateShopStockVo): API.Res<object> {
    return goodsRequest.post('/buyer/supplier/updateShopStockByRule', { data })
}

// 获取供应商品牌列表
/**
 * 获取供应商品牌列表
 */
export function querySupplierBrand(params: QuerySupplierBrandUsingGetParams): API.Res<string[]> {
    return goodsRequest.get('/buyer/supplier/querySupplierBrand', { params })
}

// 询是否可使用库存相关接口
/**
 * 查询是否可使用库存相关接口
 */
export function queryUseStockState(): API.Res<CanUseStockVo> {
    return goodsRequest.get('/buyer/supplier/queryUseStockState')
}

// 查询导出进度
/**
 * 查询导出进度
 */
export function getExportProgress(params: GetExportProcessUsingGetParams): API.Res<SkuExportResult> {
    return goodsRequest.get('/goods/goDrpGoodsExport/getExportProcess', { params })
}

// 查询复制进度
/**
 * 获取复制进度
 */
export function getCopyProcess(params: GetCopyProcessUsingGetParams): API.Res<SkuCopyResult> {
    return goodsRequest.get('/buyer/supplier/getCopyProcess', { params })
}

// 收藏供销商品
/**
 * 收藏供销商品
 */
export function batchAddFavoritesErpGoods(data: ErpSupplySalesGoodsFavoriteParam): API.Res<object> {
    return goodsRequest.post('/channel/erpSupplySalesGoodsFavorite/favoriteSupplySalesGoods', { data })
}

// 取消收藏供销商品
/**
 * 取消收藏供销商品
 */
export function batchCancelFavoritesErpGoods(data: ErpSupplySalesGoodsFavoriteParam): API.Res<object> {
    return goodsRequest.post('/channel/erpSupplySalesGoodsFavorite/cancelFavoriteSupplySalesGoods', { data })
}

// 查询创建商品导入进度
/**
 * 获取进度条
 */
export function queryProcess(params: GetProcessUsingGet5Params): API.Res<ExcelImportStatus> {
    return goodsRequest.get('/supplier/goods/getProcess', { params })
}

// 查询可限定商品
/**
 * 查询可限定商品
 */
export function queryGoodsRuleLimitItem(data: GoodsRuleLimitItemQueryVo): API.Res<GoodsRuleLimitItemQueryResult[]> {
    return goodsRequest.post('/goGoodsRuleOperate/queryGoodsRuleLimitItem', { data })
}

// 排除的商品编码从基础资料内选
/**
 * 获取简单的ERP商品列表
 */
export function queryErpGoodsSimpleSkuItem(data: QueryErpItemParam): API.Res<ErpResult[]> {
    return goodsRequest.post('/erpGoods/queryErpGoods', { data })
}

// 查询置顶商品信息
/**
 * 查询置顶商品信息
 */
export function queryMallTopGoods(data: MallTopGoodsParam): API.Res<MallTopGoodsVo[]> {
    return goodsRequest.post('/mall/goodsTop/queryMallTopGoods', { data })
}

// 置顶商品拖拽排序
/**
 * 置顶商品拖拽排序
 */
export function moveTopSort(data: MoveTopSortVo): API.Res<object> {
    return goodsRequest.post('/mall/goodsTop/moveTopSort', { data })
}

// 查询库存同步商品数量限制
/**
 * 查询库存同步商品数量限制
 */
export function switchConfigQueryCountLimit(): API.Res<number> {
    return goodsRequest.get('/switchConfig/queryCountLimit')
}

// 查询重复商品缓存列表
/**
 * 查询重复商品缓存列表
 */
export function queryRepeatCacheRecordList(data: QueryRepeatCacheListParam): API.Res<GoodsRepeatRecordResult[]> {
    return goodsRequest.post('/supplier/goods/queryRepeatCacheRecordList', { data })
}

// 根据缓存记录批量删除商品
/**
 * 根据缓存记录批量删除商品
 */
export function batchDeleteByRepeatCacheRecord(data: RepeatCacheBatchParam): API.Res<string> {
    return goodsRequest.post('/supplier/goods/batchDeleteByRepeatCacheRecord', { data })
}

// 根据缓存记录批量合并平台资料
/**
 * 根据缓存记录批量合并平台资料
 */
export function batchMergePlatformData(data: RepeatCacheBatchMergeParam): API.Res<string> {
    return goodsRequest.post('/supplier/goods/batchMergePlatformData', { data })
}

// 查询一个重复商品缓存
/**
 * 查询一个重复商品缓存
 */
export function queryOneRepeatCacheRecordList(data: QueryOneRepeatCacheListParam): API.Res<GoodsRepeatRecordResult> {
    return goodsRequest.post('/supplier/goods/queryOneRepeatCacheRecordList', { data })
}

// 校验商品是否可以加入分销小站
/**
 * 校验商品是否可以加入分销小站
 */
export function checkCanUpdateStatus(data: CheckUpdateStatusParam): API.Res<CheckUpdateStatusResultVo> {
    return goodsRequest.post('/myself/rapidly/goods/checkCanUpdateStatus', { data })
}

// 查询我的供应商列表（包含线下和线上供应商）
/**
 * 查询我的供应商列表（包含线下和线上供应商）
 */
export function listMySupplier(params: ListMySupplierUsingGetParams): API.Res<MySupplierListVo> {
    return drpRequest.get('/partner/channel/listMySupplier', { params })
}

// 获取淘宝类目销售属性数量
/**
 * 获取标题最大长度
 */
export function queryTBTitleMaxLengthRuleList(data: string[]): API.Res<CateMaxLength[]> {
    return goodsRequest.post('/shelves/taobao/v3/queryTitleMaxLengthRuleList', { data })
}

// 获取店铺商品管理资料
export function queryUpdateOnlineItemData(params) {
    return goodsRequest
        .get('/supplier/goGoodsOnlineItem/queryUpdateOnlineItemData', {
            params
        })
        .then(res => {
            // https://devops.aliyun.com/projex/req/JSTGYL-19712# 《拼多多属性唯一值替换》
            // 这是风险最小的改法
            if (params.shopType === 'Pinduoduo' && Array.isArray(res?.data?.itemOnlineData?.goodsProperties)) {
                return {
                    ...res,
                    data: {
                        ...res.data,
                        itemOnlineData: {
                            ...res.data.itemOnlineData,
                            goodsProperties: res.data.itemOnlineData.goodsProperties.map(v => ({
                                ...v,
                                id: v.refPid
                            }))
                        }
                    }
                }
            }

            return res
        })
}

/**
 * 查询日志信息
 */
/**
 * 查询最后一次铺货日志明细
 */
export function queryLastLogInfo(
    params: QueryLastTimeShelvesDetailUsingGetParams
): API.Res<QueryLastTimeShelvesDetailResult> {
    return goodsRequest.get('/supplier/itemShelvesInfo/queryLastTimeShelvesDetail', { params })
}

/**
 * 查询最后一次铺货日志明细(近7天的)
 */
/**
 * 查询最后一次铺货日志明细(近7天的)
 */
export function queryLastTimeShelvesDetailV2(
    params: QueryLastTimeShelvesDetailV2UsingGetParams
): API.Res<QueryLastTimeShelvesDetailResultV2> {
    return goodsRequest.get('/supplier/itemShelvesInfo/queryLastTimeShelvesDetailV2', { params })
}

// 查询分店信息
/**
 * 查询分店信息
 */
export function queryBranchShop(params: SelectPageUsingGetParams): API.Res<GoBranchShop[]> {
    return goodsRequest.get('/goods/goBranchShop/selectPage', { params })
}

// 同步分店信息
/**
 * 同步分店信息
 */
export function syncBranchShop(data: GoBranchShop): API.Res<string> {
    return goodsRequest.post('/goods/goBranchShop/syncBranchShop', { data })
}

// 查询分店地址
/**
 * 查询分店地址
 */
export function queryBranchShopAddress(params: SelectShopAddressUsingGetParams): API.Res<ShopAddress[]> {
    return goodsRequest.get('/goods/goBranchShop/selectShopAddress', { params })
}

// 是否需要同步店铺
/**
 * 店铺是否需要同步分店
 */
export function needSyncShop(params: NeedSyncShopUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/goods/goBranchShop/needSyncShop', { params })
}

// 待检商品数据包含的敏感词
/**
 * 校验商品平台资料包含的敏感词
 */
export function checkGoodsSensitiveWords(data: SensitiveWordsCheckVo[]): API.Res<SensitiveWordsCheckVo[]> {
    return goodsRequest.post('/sensitiveWords/checkGoodsSensitiveWords', { data })
}

// 列出所有启用状态的敏感词
export function listAllEnabledSensitiveWords(params) {
    const goodsRequestCache = getCacheService(goodsRequest)
    return goodsRequestCache.get('/sensitiveWords/listAllEnabledSensitiveWords', {
        params
    })
}

// 分页查询敏感词库
/**
 * 分页查询敏感词库
 */
export function querySensitiveWordsList(data: SensitiveWordsQuery): API.Res<SensitiveWords[]> {
    return goodsRequest.post('/sensitiveWords/list', { data })
}

// 新增敏感词
/**
 * 新增敏感词
 */
export function insertSensitiveWords(data: SensitiveWordsInsertVo): API.Res<number> {
    return goodsRequest.post('/sensitiveWords/insert', { data })
}

// 删除敏感词
/**
 * 删除敏感词
 */
export function deleteSensitiveWords(data: SensitiveWordsDeleteVo): API.Res<number> {
    return goodsRequest.post('/sensitiveWords/delete', { data })
}

// 更新敏感词启用-禁用状态
/**
 * 更新敏感词启用/禁用状态
 */
export function updateSensitiveWords(data: SensitiveWordsUpdateVo): API.Res<number> {
    return goodsRequest.post('/sensitiveWords/update', { data })
}

// 列出所有创建过敏感词的用户名
/**
 * 列出所有创建过敏感词的用户名
 */
export function listAllCreateUsername(): API.Res<string[]> {
    return goodsRequest.get('/sensitiveWords/listAllCreateUsername')
}

// 查询供应商商品列表
/**
 * 查询供应商商品列表
 */
export function queryFreshmanList(data: BuyerSupplierGoodsQuery1): API.Res<BuyerSpuVo[]> {
    return goodsRequest.post('/freshman/mall/goods/list', { data })
}

// 查询商品权重明细
/**
 * 查询商品排序权重信息
 */
export function queryFreshManGoodsSortWeightList(data: CoIdAndSpuId[]): API.Res<SellWellSortWeightVo[]> {
    return marketRequest.post('/freshman/goods/queryGoodsSortWeightList', { data })
}

// 查询是否能查看分销大店商家的库存信息
/**
 * 查询是否能查看分销大店商家的库存信息
 */
export function queryBigShopAllowViewStock(): API.Res<BigShopAllowViewStock[]> {
    return drpRequest.get('/partner/channel/queryBigShopAllowViewStock')
}

// 一键自动调整图片尺寸 最多 300张，
/**
 * 一键自动调整图片尺寸
 */
export function imageResize(data: ImageHandlerParam[]): API.Res<ImageHandlerResult[]> {
    return goodsRequest.post('/oss/imageResize', { data })
}

/**
 * 查询是否是供应商商品(新写的接口解决需求：https://devops.aliyun.com/projex/req/JSTGYL-13704# 《分销铺货-分销商修改商品编码时提示风险》)
 * 返回 true  就是指供应商商品，false就是自己的商品
 * @param itemSpuId
 */
export function checkIsDrpGoods(params) {
    const goodsRequestCache = getCacheService(goodsRequest)
    return goodsRequestCache.get('/goods/checkIsDrpGoods', {
        params
    })
}

// 查询类目
export function queryCategoryByCateIdList(params) {
    const goodsRequestCache = getCacheService(goodsRequest)
    return goodsRequestCache.get('/platform/category/listByCateIdList', {
        params
    })
}

// 查询商品的sku数据
/**
 * 查询商品的sku数据
 */
export function querySkuInfoBySpuId(data: QueryGoodsDetail): API.Res<SkuDetailInfoVo> {
    return goodsRequest.post('/goods/querySkuInfoBySpuId', { data })
}

// 查询线上商品平台资料(根据线上商品ID)
/**
 * 查询线上商品平台资料
 */
export function queryOnlineItemPlatformData(data: OnlineItemShelvesInfoParam): API.Res<UpdateShopOnlineItemData> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/queryOnlineItemPlatformData', { data })
}

// 处理选择的线上价格
/**
 * 处理选择的线上价格
 */
export function analysisSelectedUpdateOnlinePrice(data: SelectedUpdateOnlinePriceVo): API.Res<string> {
    return goodsRequest.post('/online/goods/analysisSelectedUpdateOnlinePrice', { data })
}

// 检查是否代发商品
export function checkDistributionGoods(data) {
    const queryBrandCache = postCacheService(goodsRequest)
    return queryBrandCache.post('/goods/checkDistributionGoods', {
        data
    })
}

// 查看线上关联商品
/**
 * 查看线上关联商品
 */
export function queryShopSpuForUpdate(data: ShopSpuItemParam): API.Res<ShopSpuItem[]> {
    return goodsRequest.post('/shop/shopSpu/queryShopSpuForUpdate', { data })
}

// 查看供应商店铺商品关联款信息
export async function querySupplierShopSpuForUpdate(data) {
    const res = await goodsRequest
        .post('/supplier/shopManage/querySupplierShopSpuForUpdate', {
            data
        })
        .then(res => {
            if (Array.isArray(res.data)) {
                res.data = res.data.map(item => {
                    // 后端返回可能为空，前端要做匹配逻辑
                    if (!item.shopStyleCode) {
                        return {
                            ...item,
                            shopStyleCode: uuidv4()
                        }
                    }

                    return item
                })
            }

            return res
        })

    return res
}

/**
 * 查询日志信息
 * @param {*} params.id id 日志明细ID
 * @returns
 */
export async function querySpuLogInfo(params) {
    const res = await goodsRequest
        .get('/supplier/itemShelvesInfo/queryShelvesDetailPlatformData', {
            params
        })
        .then(res => {
            // https://devops.aliyun.com/projex/req/JSTGYL-19712# 《拼多多属性唯一值替换》
            // 这是风险最小的改法
            if (params.shopType === '拼多多' && Array.isArray(res?.data?.goodsProperties)) {
                return {
                    ...res,
                    data: {
                        ...res.data,
                        goodsProperties: res?.data?.goodsProperties.map(v => ({
                            ...v,
                            id: v.refPid
                        }))
                    }
                }
            }

            return res
        })
    if (!res.success) {
        Sentry.setExtra('params', { ...params, url: '/supplier/itemShelvesInfo/queryShelvesDetailPlatformData' })
        Sentry.captureException(new Error(res.message))
    }
    return res
}

// 获取基础资料
/**
 * 查询待发布的商品信息
 */
export function querySpuInfo(data: QueryShelvesParam): API.Res<ItemSpuShelvesVo> {
    return goodsRequest.post('/shelves/itemSpuShelves/getItemSpuInfo', { data })
}

/**
 * 查询商品是否自己
 * @param itemSpuId
 */
export function checkGoodsIsMe(params) {
    const goodsRequestCache = getCacheService(goodsRequest)
    return goodsRequestCache.get('/goods/checkGoodsIsMe', { params })
}

// 获取ERP商品编码列表
/**
 * 获取ERP商品编码列表
 */
export function getErpItemCodeListByPartnerSpuId(
    params: GetErpItemCodeListByPartnerSpuIdUsingGetParams
): API.Res<string[]> {
    return goodsRequest.get('/buyer/partnerSpu/getErpItemCodeListByPartnerSpuId', { params })
}

// 查询平台资料使用的店铺信息
/**
 * 查询平台资料使用的店铺信息
 */
export function queryPlatformUseShopId(params: QueryPlatformUseShopUsingGetParams): API.Res<string> {
    return goodsRequest.get('/goods/platform/queryPlatformUseShopId', { params })
}

// 我的小站SKU列表
export const queryBuyerSkuList = data => {
    const goodsRequestCache = postCacheService(goodsRequest)
    return goodsRequestCache.post('/buyer/supplier/goods/skuList', {
        data
    })
}

// 我的小站SKU列表
/**
 * 查询供应商sku列表
 */
export function queryBuyerSkuListOpen(data: BuyerSupplierSkuQueryParam): API.Res<BuyerSkuVo[]> {
    return openGoodsRequest.post('/open/supplier/goods/pc/skuList', { data })
}

// 我的小站SKU列表异步查询sku部分字段
/**
 * 异步查询sku部分字段
 */
export function asyncQuerySkuAdditional(data: BuyerAdditionalSkuQueryVo): API.Res<BuyerSkuAdditionalVo[]> {
    return goodsRequest.post('/buyer/supplier/asyncQuerySkuAdditional', { data })
}

// 我的小站SKU列表异步查询sku部分字段
/**
 * 异步查询sku部分字段
 */
export function asyncQuerySkuAdditionalOpen(data: BuyerAdditionalSkuQueryVo): API.Res<BuyerSkuAdditionalVo[]> {
    return openGoodsRequest.post('/open/supplier/goods/asyncQuerySkuAdditional', { data })
}

// SKU数据展示是否准备完成
/**
 * SKU数据展示是否准备完成
 */
export function checkSkuIfShow(params: CheckSkuIfShowUsingGet1Params): API.Res<boolean> {
    return goodsRequest.get('/buyer/supplier/checkSkuIfShow', { params })
}

// SKU数据展示是否准备完成
/**
 * SKU数据展示是否准备完成
 */
export function checkSkuIfShowOpen(params: CheckSkuIfShowUsingGet2Params): API.Res<boolean> {
    return openGoodsRequest.get('/open/supplier/goods/checkSkuIfShow', { params })
}

/**
 * 商品外链图片转内链
 */
export function imageToOss(data: ImageToOssVo): API.Res<ImageToOssResult[]> {
    return goodsRequest.post('/oss/imageToOss', { data })
}

// 查询商家铺货成功率
/**
 * 查询商家铺货成功率
 */
export function queryShelvesSuccessRate(): API.Res<ShelvesSuccessRate> {
    return goodsRequest.get('/statistics/queryShelvesSuccessRate')
}

// 查询商家商家相关数量
/**
 * swagger找不到此接口
 */
export function queryShelvesStatistics(params) {
    return goodsRequest.get('/goods/itemShelvesInfo/queryShelvesStatistics', {
        params
    })
}

// 类目属性模版-删除
/**
 * 删除类目属性模版
 */
export function categoryPropTemplateRemove(data: DeleteTemplateVo): API.Res<object> {
    return goodsRequest.post('/goods/goCategoryPropTemplate/remove', { data })
}

// 类目属性模版-查询
export const categoryPropTemplateQuery = data => {
    return new Promise((resolve, reject) => {
        goodsRequest
            .post('/goods/goCategoryPropTemplate/selectTemplate', {
                data
            })
            .then(response => {
                const newData = response?.data?.map?.(v => {
                    const categoryProp = JSON.parse(v.categoryProp)

                    // https://devops.aliyun.com/projex/req/JSTGYL-19712# 《拼多多属性唯一值替换》
                    // 这是风险最小的改法
                    if (data.shopType === 'Pinduoduo' && Array.isArray(categoryProp)) {
                        return {
                            ...v,
                            categoryProp: categoryProp.map(v1 => ({
                                ...v1,
                                id: v1.refPid
                            }))
                        }
                    }

                    return {
                        ...v,
                        categoryProp
                    }
                })

                const newRes = {
                    ...response,
                    data: newData
                }

                resolve(newRes)
            })
            .catch(reject)
    })
}

// 类目属性模版-增改
export const categoryPropTemplateUpsert = data =>
    goodsRequest.post('/goods/goCategoryPropTemplate/upsertCategoryPropTemplate', {
        data: {
            ...data,
            categoryProp: JSON.stringify(data.categoryProp)
        }
    })

// 校验无法铺货的店铺
/**
 * 校验无法铺货的店铺
 */
export function checkCannotShelvesShop(data: CannotShelvesShopParam): API.Res<CannotShelvesShopResult> {
    return goodsRequest.post('/preBatchShelves/checkCannotShelvesShop', { data })
}

// 类目属性模版-日志
/**
 * 查询模版操作日志列表
 */
export function categoryPropTemplateLog(params: ListUsingGet4Params): API.Res<GoTemplateLog[]> {
    return goodsRequest.get('/goods/goTemplateLog/list', { params })
}

// 加载寻合作爆款专区基础配置
/**
 * 加载寻合作爆款专区基础配置
 */
export function getLookForHotSellConfigAPI(): API.Res<HotSellConfigVo> {
    return drpRequest.get('/baseConfig/getLookForHotSellConfig')
}

/**
 * 查询商品状态列是否展示
 */

/**
 * 查询商品信息是否需要展示sku状态
 */
export function showErpSkuStatus(params: CheckShowErpSkuStatusUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/shelves/itemSpuShelves/showErpSkuStatus', { params })
}

/**
 * 查询商品搜索关键词列表
 */
/**
 * 查询商品搜索关键词列表
 */
export function querySearchKeywordV2(params: QuerySearchKeywordUsingGet1Params): API.Res<GoGoodsSearchKeywordVo[]> {
    return goodsBasicRequest.get('/goGoodsSearchKeyword/querySearchKeywordV2', { params })
}

/**
 * 查询商品搜索关键词列表
 */
/**
 * 删除商品搜索关键词
 */
export function removeSearchKeywordV2(data): API.Res<object> {
    return goodsBasicRequest.post('/goGoodsSearchKeyword/removeSearchKeywordV2', {
        data
    })
}

/**
 * 保存商品搜索关键词
 */
export function doSaveSearchKeyword(data): API.Res<object> {
    return goodsBasicRequest.post('/goGoodsSearchKeyword/doSaveSearchKeyword', {
        data
    })
}

// 加载寻合作找商品基础配置
/**
 * 加载寻合作找商品基础配置
 */
export function loadFindGoodsConfig(): API.Res<FindGoodsConfigVo> {
    return drpRequest.get('/baseConfig/loadFindGoodsConfig')
}

/**
 * 查询商品台资料完善标已过期数量
 */

/**
 * 查询商品台资料完善标已过期数量
 */
export function queryGoodsPlatformPerfectExpireCount(): API.Res<Record<string, number>> {
    return goodsRequest.get('/goodsPlatformPerfectExpire/queryGoodsPlatformPerfectExpireCount')
}

/**
 * 查询分销铺货失败的商品各平台资料数量
 */
/**
 * 查询分销铺货失败的商品各平台资料数量
 */
export function queryPlatformShelvesFailCount(): API.Res<Record<string, number>> {
    return goodsRequest.get('/goodsDisShelves/queryPlatformShelvesFailCount')
}

/**
 * 获取合伙人邀约设置的分销等级
 */

/**
 * 获取合伙人邀约设置的分销等级
 */
export function getPartnerDisLevel(params: GetPartnerDisLevelUsingGet1Params): API.Res<number> {
    return drpRequest.get('/partner/supplier/getPartnerDisLevel', { params })
}

/**
 * 查询检查商品平台资料完善标是否过期任务状态信息
 */

/**
 * 查询检查商品平台资料完善标是否过期任务状态信息
 */
export function getGoodsPlatformPerfectExpireTaskInfo(): API.Res<TaskStatusInfoVo> {
    return goodsRequest.get('/goodsPlatformPerfectExpire/getGoodsPlatformPerfectExpireTaskInfo')
}

// 置顶商品拖拽排序
/**
 * 触发检查商品平台资料完善标是否过期任务
 */
export function startCheckGoodsPlatformPerfectExpireTask(): API.Res<string> {
    return goodsRequest.post('/goodsPlatformPerfectExpire/startCheckGoodsPlatformPerfectExpireTask')
}

// 被限制分销上架的商品
/**
 * 被限制分销上架的商品
 */
export function limitShelvesPlatformGoods(data: CheckLimitShelvesPlatformParam): API.Res<SpuIdAndStyleCode[]> {
    return goodsRequest.post('/buyer/shelves/limitShelvesPlatformGoods', { data })
}

// 查询供应商的商品分销控价拦截上架状态
/**
 * 查询供应商的商品分销控价拦截上架状态
 */
export function querySpuRegulatePriceInterceptList(data: CoIdAndSpuId[]): API.Res<SpuRegulatePriceInterceptVo[]> {
    return goodsRequest.post('/supplier/goods/querySpuRegulatePriceInterceptList', { data })
}

// 查询未完善商品详情列表
/**
 * 查询未完善商品详情列表
 */
export function queryNotPerfectGoodsDetailList(data: PreShelvesGoodsInfoParam): API.Res<NotPerfectGoodsInfo[]> {
    return goodsRequest.post('/preBatchShelves/queryNotPerfectGoodsDetailList', { data })
}

// 一键填充平台资料类目属性
/**
 * 一键填充平台资料类目属性
 */
export function fillPlatformCategoryProp(data: FillGoodsCategoryPropParam[]): API.Res<string> {
    return goodsRequest.post('/preBatchShelves/fillPlatformCategoryProp', { data })
}

// 查询标签列表
export function getLabelList() {
    const getFreshmanGoodsLabelList = getCacheService(marketRequest)
    return getFreshmanGoodsLabelList.get('/freshman/goods/label/list', {})
}

// 查询标签列表-20240314
export function getLabelListAll() {
    const getFreshmanGoodsLabelList = getCacheService(marketRequest)
    return getFreshmanGoodsLabelList.get('/freshman/goods/label/allLabels', {})
}

// 爆款专区需要去除新品标
export function getDisplayLabelListAll() {
    const getFreshmanGoodsLabelList = getCacheService(marketRequest)
    return getFreshmanGoodsLabelList.get('/freshman/goods/label/allDisplayLabels', {})
}

// 查询标签列表-20240314
export function queryTileLabels(params: QueryTileLabelsUsingGetParams = {}): API.Res<GoodsFreshmanLabelVo[]> {
    const getFreshmanGoodsLabelList = getCacheService(marketRequest)
    return getFreshmanGoodsLabelList.get('/freshman/goods/label/queryTileLabels', { params })
}

/**
 * 获取后台配置的类目推荐关键字（找商品空态推荐）
 */

export function getFindGoodsRecCateHotKeyList(params) {
    return securityRequest.get('/security/config/find', {
        params
    })
}

// /buyer/supplier/asyncQueryDisErpGoods
/**
 * 异步查询供应商ERP分销商品-发送请求
 */
export function asyncQueryDisErpGoods(data: DisErpGoodsQuery): API.Res<string> {
    return goodsRequest.post('/buyer/supplier/asyncQueryDisErpGoods', { data })
}

/**
 * 异步查询供应商ERP分销商品-查询回调数据
 */
export function asyncQueryDisErpGoodsData(params: AsyncQueryDisErpGoodsDataUsingGetParams): API.Res<ErpDisSku[]> {
    return goodsRequest.get('/buyer/supplier/asyncQueryDisErpGoodsData', { params })
}

/**
 * 新增缓存
 */
export function cacheAdd(data: InnerOpenCacheVo): API.Res<string> {
    return goodsRequest.post('/cache/add', { data })
}

/**
 * 被限制分销上架的平台
 */
export function limitShelvesPlatforms(data: LimitShelvesPlatformsParam): API.Res<string[]> {
    return goodsRequest.post('/buyer/shelves/limitShelvesPlatforms', { data })
}

// 异步查询卡片详情部分字段
/**
 * 异步查询卡片详情部分字段
 */
export function asyncQueryCardDetailFields(data: CoIdAndSpuId[]): API.Res<CardDetailResult[]> {
    return goodsRequest.post('/goods/asyncQueryCardDetailFields', { data })
}

// 查询供应商入驻寻合作找供应商状态
/**
 * 查询供应商入驻寻合作找供应商状态
 */
export function findCoopSupplierStatus(): API.Res<FindCoopSupplierStatusVo> {
    return drpRequest.get('/findCooperation/supplier/findCoopSupplierStatus')
}

/**
 * @description:  复制商品平台资料
 * @param {sourceSpuId} 复制来源商品的spuId
 * @param {newStyleCode} 新商品的款式编码
 * @returns {*}
 */
/**
 * 复制商品
 */
export function copyGoods(data: CopyGoodsVo): API.Res<string> {
    return goodsRequest.post('/supplier/goods/copyGoods', { data })
}

/**
 * 查询抖音店铺是否被处罚/无权限/保证金不足
 */
/**
 * 校验无法铺货的店铺V2
 */
export function checkCannotShelvesShopV2(data: CannotShelvesShopParam): API.Res<CannotShelvesShopResultV2[]> {
    return goodsRequest.post('/preBatchShelves/checkCannotShelvesShopV2', { data })
}

// 得物批量创建货单匹配
/**
 * 得物批量创建货单匹配
 */
export function dewuBatchCreateGoodsMatch(data: BatchCreateGoodsMatchParam): API.Res<object> {
    return goodsRequest.post('/shelves/dewu/batchCreateGoodsMatch', { data })
}

/**
 * 按款批量绑定对应关系
 */
/**
 * 按款批量绑定对应关系
 */
export function bindSpuLink(data: BindLinkParam): API.Res<string> {
    return goodsRequest.post('/shopManage/bindSpuLink', { data })
}

/**
 * 按款批量解绑对应关系
 */
/**
 * 按款批量解绑对应关系
 */
export function relieveBindSpuLink(data: ShopItem[]): API.Res<string> {
    return goodsRequest.post('/shopManage/relieveBindSpuLink', { data })
}

/**
 * 按SKU批量绑定对应关系
 */
/**
 * 按SKU批量绑定对应关系
 */
export function bindSkuLink(data: BindLinkParam): API.Res<object> {
    return goodsRequest.post('/shopSkuManage/bindSkuLink', { data })
}

/**
 * 按SKU批量解绑对应关系
 */
/**
 * 按SKU批量解绑对应关系
 */
export function relieveBindSkuLink(data: ShopItem[]): API.Res<object> {
    return goodsRequest.post('/shopSkuManage/relieveBindSkuLink', { data })
}

/**
 * 选择erp商品
 */
/**
 * 获取ERP全面信息SKU列表
 */
export function queryErpComprehensiveSkuList(data: QueryErpComprehensiveSkuParam): API.Res<ErpComprehensiveSku[]> {
    return goodsRequest.post('/erpGoods/queryErpComprehensiveSkuList', { data })
}

/**
 * 店铺商品按SKU批量导出
 */
/**
 * 按SKU批量导出
 */
export function exportSku(data: ExportSkuParam): API.Res<string> {
    return goodsRequest.post('/shopSkuManage/exportSku', { data })
}

/**
 * 店铺商品按SKU批量导出进度
 */
/**
 * 查询导出结果
 */
export function queryExportData(params: QueryExportDataUsingGetParams): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/shopSkuManage/queryExportData', { params })
}

/**
 * 查询主商品的渠道商品总数
 */
/**
 * 查询主商品的渠道商品总数
 */
export function queryMainProductChannelTotal(params: QueryMainProductChannelTotalUsingGetParams): API.Res<number> {
    return goodsRequest.get('/douYin/channelProduct/queryMainProductChannelTotal', { params })
}

/**
 * 校验拼多多铺货授权
 */
/**
 * 校验拼多多铺货授权
 */
export function checkPddShelvesAuthorization(data: PddShelvesAuthorizationParam): API.Res<boolean> {
    return goodsRequest.post('/shelves/pddShelves/checkPddShelvesAuthorization', { data })
}

/**
 * 确认同意拼多多铺货协议
 */
/**
 * 确认同意拼多多铺货协议
 */
export function confirmAgreePddShelvesAuthorization(): API.Res<object> {
    return goodsRequest.post('/supplierConfig/confirmAgreePddShelvesAuthorization')
}

/**
 * 查询上报商品详情
 */
/**
 * 查询上报商品详情
 */
export function queryReportGoodsDetail(params: QueryReportGoodsDetailUsingGetParams): API.Res<ReportMsgVo> {
    return goodsRequest.get('/pdd/report/queryReportGoodsDetail', { params })
}

/**
 * 查询指定类目在爆款专区类目树中是否存在
 * @param {*} params
 * @returns
 */
/**
 * 查询在爆款专区的类目
 */
export function queryInFreshmanCategory(
    params: QueryInFreshmanCategoryUsingGetParams
): API.Res<QueryInFreshmanCategoryResult> {
    return drpRequest.get('/mainCategory/queryInFreshmanCategory', { params })
}

/*
 * 查询视频文件信息列表
 */
/**
 * 查询视频文件信息列表
 */
export function queryVideoInfoList(data: string[]): API.Res<VideoVo[]> {
    return goodsRequest.post('/oss/queryVideoInfoList', { data })
}

// 校验供应商变更同步
/**
 * 校验供应商变更同步
 */
export function checkSupplierChangeSync(params): API.Res<SupplierChangeSyncResp> {
    return goodsRequest.post('/supplier/goods/checkSupplierChangeSync', {
        params
    })
}

// 批量校验供应商变更同步
/**
 * 校验供应商变更同步
 */
export function checkSupplierChangeSyncV2(data: ChangeCheckSyncParam): API.Res<SupplierChangeSyncResp> {
    return goodsRequest.post('/supplier/goods/checkSupplierChangeSyncV2', { data })
}

// 保存商品后同步
/**
 * 保存商品后同步
 */
export function syncAfterSaveGoods(data: SyncAfterSaveGoodsParam): API.Res<object> {
    return goodsRequest.post('/supplier/goods/syncAfterSaveGoods', { data })
}

/**
 * 更新商品套图
 */
/**
 * 更新商品套图
 */
export function updateGoodsMultiplePic(data: UpsertSpuVo): API.Res<object> {
    return goodsRequest.post('/supplier/goods/updateGoodsMultiplePic', { data })
}

/**
 * 批量保存商品后同步
 */
/**
 * 批量保存商品后同步
 */
export function batchSyncAfterSaveGoods(data: SyncAfterSaveGoodsParam): API.Res<object> {
    return goodsRequest.post('/supplier/goods/batchSyncAfterSaveGoods', { data })
}

/**
 /*
 * 查询供应商商品品牌列表
 */
/**
 * 查询供应商品牌列表
 */
export function listSupplierBrand(params: ListSupplierBrandUsingGetParams): API.Res<string[]> {
    return goodsRequest.get('/buyer/supplier/listSupplierBrand', { params })
}

/*
 * 带平台的类目预测
 */
/**
 * 带平台的类目预测
 */
export function categoryForecastWithPlatform(
    data: CategoryForecastPlatformParam
): API.Res<CategoryForecastPlatformResult[]> {
    return goodsRequest.post('/platform/category/categoryForecastWithPlatform', { data })
}

/** 查询商品起采数量参数 */
export interface QueryGoodsBuyLimitNumParams {
    /** 商品所属分销商 coId */
    itemCoId: string

    /** 商品 spuId 集合 */
    itemSpuIdList: string[]
}

/** 查询起采数量接口参数 */
export interface QueryBuyLimitNumParams {
    /** 当前用户 coId */
    coId?: string

    /** 查询商品起采数量参数 */
    queryParamList: QueryGoodsBuyLimitNumParams[]
}

/** 查询起采数量接口返回数据 */
export interface QueryBuyLimitNumResponseData {
    /** 起采数量 */
    buyLimitNum: number

    /** 商品所属coId */
    itemCoId: string

    /** 商品Id */
    itemSpuId: string
}

/** 查询起采数量 */
export function queryBuyLimitNum(data: QueryBuyLimitNumParams): API.Res<QueryBuyLimitNumResponseData[]> {
    return goodsRequest.post('/supplier/goods/queryBuyLimitNum', { data })
}

/** 更新起采数量接口参数 */
export interface UpdateBuyLimitNumParams {
    /** 起采数量 */
    buyLimitNum: number | undefined

    /** 商品 spuId 集合 */
    itemSpuIdList: string[]

    /** 更新类型 clear:清空 update:更新 */
    updateBuyListNumType: 'clear' | 'update'
}

/** 批量修改 SPU 起采数量 */
export function batchUpdateBuyLimitNumBySpu(data: UpdateBuyLimitNumParams): API.Res<void> {
    return goodsRequest.post('/myself/batch/goods/batchUpdateBuyLimitNumBySpu', { data })
}

/** 清空起采数量采用默认配置 */
export function clearAllSetBuyLimit(): API.Res<void> {
    return goodsRequest.post('/myself/batch/goods/clearAllSetBuyLimit', {})
}

/** 清空起采数量采用默认配置 */
export function queryShelvesSpecialTips() {
    return goodsRequest.get('/goods/goGoodsDouyin/queryShelvesSpecialTips', {})
}

/**
 * 商家是否有1688导入模板
 */
export function haveAlibabaImportTemplateUsingGET(params: HaveAlibabaImportTemplateUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/goods/goItemShelvesTemplate/haveAlibabaImportTemplate', { params })
}

/**
 * 查询店铺商品限制和清理是否开启
 */
export function queryItemCleanEnabledUsingGET(params?: QueryItemCleanEnabledUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/shopManage/queryItemCleanEnabled', { params })
}

/**
 * 查询店铺商品总数和上限
 */
export function queryShopItemTotalAndLimitUsingGET(
    params?: QueryShopItemTotalAndLimitUsingGetParams
): API.Res<QueryShopItemLimitVo> {
    return goodsRequest.get('/shopManage/queryShopItemTotalAndLimit', { params })
}

/**
 * 店铺商品管理按款列表(售后多地址策略)
 */
export function afterSaleQueryShopItemSpuList(data: ShopManageAfterSaleSpuQuery): API.Res<ShopItemSpuVo[]> {
    return goodsRequest.post('/shopManage/afterSaleQueryShopItemSpuList', { data })
}

/**
 * 查询是否有待清理数据
 */
export function queryHaveCleanFlagItemUsingGET(params?: QueryHaveCleanFlagItemUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/shopManage/queryHaveCleanFlagItem', { params })
}

/**
 * 删除店铺商品
 */
export function deleteShopItemUsingPOST(data: DeleteShopItemParamData[]): API.Res<DeleteShopItemVo> {
    return goodsRequest.post('/shopManage/deleteShopItem', { data })
}

/** 刷新商品状态 */
export function refreshStatusUsingPOST(data: FreshmanSpuIdVo): API.Res<FreshmanRefreshStatusVo> {
    return goodsRequest.post('/freshman/goods/refreshStatus', { data })
}

/** 查询排除原因列表 */
export function queryExcludeReasonListUsingGET(params: QueryExcludeReasonListUsingGetParams): API.Res<string[]> {
    return goodsRequest.get('/freshman/goods/queryExcludeReasonList', { params })
}

/**
 * 查询供应商小程序铺货引导白名单列表
 */
export function queryAppShelvesGuideWhiteListUsingGET1(): API.Res<string[]> {
    return goodsRequest.get('/switchConfig/queryAppShelvesGuideWhiteList')
}

/**
 * 查询ERP普通商品资料成本价按销售价折扣计算（成本价比率）开关是否开启
 */
export function queryErpCostPriceRateEnableUsingGET(): API.Res<boolean> {
    return goodsRequest.get('/myself/rapidly/sku/queryErpCostPriceRateEnable')
}

export function taobaoInterceptShelves(data): API.Res<boolean> {
    return goodsRequest.post('/shelves/taobao/v3/interceptShelves', { data })
}

/**
 * 日志分销商品拼款获取缓存商品ID集合
 */
export function queryPreSalePlatformListUsingPOST(data: QueryPresaleMarkParam): API.Res<PresaleMarkVo> {
    return goodsRequest.post('/partnerSpu/shelves/queryPreSalePlatformList', { data })
}

/**
 * 供应商小站SPU列表
 */
export function querySupplierGoodsList(data: BuyerSupplierGoodsQueryForMall): API.Res<BuyerSpuVo[]> {
    const goodsRequestCache = postCacheService(goodsRequest)
    return goodsRequestCache.post('/buyer/supplier/goods/list', { data })
}

/**
 * 带商品名称和图片预测抖音类目
 */
export function categoryForecastDyWithNameAndMainImageUsingPOST(
    data: CategoryForecastWithNameAndMainImageParam
): API.Res<CategoryForecastWithNameAndMainImageResult[]> {
    return goodsRequest.post('/goods/goGoodsDouyin/categoryForecastDyWithNameAndMainImage', { data })
}

/**
 * 查询勾选的列表
 */
export function queryPreListUsingPOST(data: ForecastPreListQueryParam): API.Res<ForecastPreListVo[]> {
    return goodsRequest.post('/goods/platformForecast/queryPreList', { data })
}

/**
 * 开始AI智能填充资料
 */
export function startImproveUsingPOST(data: StartPlatformForecastParam[]): API.Res<object> {
    return goodsRequest.post('/goods/platformForecast/startImprove', { data })
}

/**
 * 查询类目信息
 */
export function queryCategoryUsingPOST1(data: ForecastCategoryQueryParam): API.Res<ForecastCategoryResp[]> {
    return goodsRequest.post('/goods/platformForecast/queryCategory', { data })
}

/**
 * 查询可填充商品数量
 */
export function queryCanImproveWithAiCountUsingGET(
    params: QueryCanImproveWithAiCountUsingGetParams
): API.Res<Record<string, number>> {
    return goodsRequest.get('/goods/platformForecast/queryCanImproveWithAiCount', { params })
}

/**
 * 带平台的类目预测
 */
export function categoryForecastWithPlatformV2UsingPOST(
    data: CategoryForecastPlatformParam
): API.Res<CategoryForecastPlatformResult[]> {
    return goodsRequest.post('/platform/category/categoryForecastWithPlatformV2', { data })
}

/**
 * 获取店铺商品sku明细（达人采购）
 */
export function queryShopItemSkuDetailInfoUsingPOST(data: ShopDetailParamVo): API.Res<SkuDetailInfoVo> {
    return goodsRequest.post('/shopItemDetail/queryShopItemSkuDetailInfo', { data })
}

/**
 * 淘宝铺货风控拦截开关V2
 */
export function interceptShelvesEnableV2UsingGET(): API.Res<boolean> {
    return goodsRequest.get('/shelves/taobao/v3/interceptShelvesEnableV2')
}

/**
 * 查询已完善平台类目列表
 */
export function queryPerfactPlatformListUsingPOST(data: ForecastPreListQueryParam): API.Res<PlatformAndCategoryVo[]> {
    return goodsRequest.post('/goods/platformForecast/queryPerfactPlatformList', { data })
}

/**
 * 查询ERP商品编码状态和成本价比率
 */
export function queryErpItemCodeStatusUsingPOST(data: string[]): API.Res<ErpItemCodeVo[]> {
    return goodsRequest.post('/supplier/goods/queryErpItemCodeStatus', { data })
}

/**
 * queryAiForecastStatisticsAll
 */
export function queryAiForecastStatisticsAllUsingGET(): API.Res<AiForecastStatisticsVo> {
    return goodsBasicRequest.get('/forecast/queryAiForecastStatisticsAll')
}

/**
 * 查询商品配置的日志
 */
export function listUsingGET(params: ListUsingGetParams): API.Res<GoGoodsConfigLog[]> {
    return goodsBasicRequest.get('/goodsConfigLog/listByType', { params })
}

/**
 * 查询商品配置的日志详情
 */
export function detailUsingGET(params: DetailUsingGetParams): API.Res<string> {
    return goodsBasicRequest.get('/goodsConfigLog/detail', { params })
}

/*
 * 一键图片缩放
 */
export function imageZoomUsingPOST(data: ImageZoomParam[]): API.Res<ImageHandlerResult[]> {
    return goodsRequest.post('/oss/imageZoom', { data })
}

/**
 * 开始AI智能填充资料Single
 */
export function startImproveSingleUsingPOST(data: StartPlatformImproveParam): API.Res<string> {
    return goodsRequest.post('/goods/platformForecast/startImproveSingle', { data })
}

/**
 * 查询预测统计
 */
export function queryAiForecastQuotaUsingPOST(): API.Res<ForecastQuotaResp> {
    return goodsRequest.post('/goods/platformForecast/queryAiForecastQuota')
}

/**
 * 获取任务状态
 */
export function queryTaskUsingGET4(params: QueryTaskUsingGet4Params): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/goods/platformForecast/queryTask', { params })
}

/**
 * 查询AI平台资料信息
 */
export function queryAiPlatformInfoUsingPOST(data: QueryAiPlatFormInfoVo): API.Res<QueryAiPlatFormInfoVo> {
    return goodsRequest.post('/goods/platformForecast/queryAiPlatformInfo', { data })
}

/**
 * 获取预测的店铺ID
 */
export function getForecastShopIdUsingPOST(data: QueryForecastShopIdParam): API.Res<string> {
    return goodsRequest.post('/goods/platformForecast/getForecastShopId', { data })
}

/**
 * 带商品名称和图片预测抖音类目
 */
export function categoryForecastDyWithNameAndMainImageV2UsingPOST(
    data: CategoryForecastWithNameAndMainImageParam
): API.Res<CategoryForecastWithNameAndMainImageResult[]> {
    return goodsRequest.post('/goods/goGoodsDouyin/categoryForecastDyWithNameAndMainImageV2', { data })
}

/**
 * 查询通知
 */
export function queryNoticeUsingPOST(data: NoticeTypeList): API.Res<QueryNoticeResult[]> {
    return goodsRequest.post('/notice/queryNotice', { data })
}

/**
 * 查询通知状态
 */
export function queryNoticeStatusListUsingPOST(data: QueryNoticeStatusParam): API.Res<NoticeStatus[]> {
    return goodsRequest.post('/notice/queryNoticeStatusList', { data })
}

/**
 * 清理已完成的通知
 */
export function clearCompleteNoticeUsingPOST(data: NoticeTypeList): API.Res<object> {
    return goodsRequest.post('/notice/clearCompleteNotice', { data })
}

/**
 * 取消AI智能填充资料
 */
export function cancelImproveUsingPOST(data: CancelPlatformImproveParam): API.Res<object> {
    return goodsRequest.post('/goods/platformForecast/cancelImprove', { data })
}

/**
 * 当前商家是否是付费商家
 */
export function companyPaymentContractUsingGET(): API.Res<boolean> {
    return goodsRequest.get('/goChannelPartnerSpu/companyPaymentContract')
}

/**
 * 导出sku
 */
export function exportSku1(data: ShopLinkExportParam): API.Res<string> {
    return goodsRequest.post('/partnerSpu/shopLink/exportSku', { data })
}

/**
 * 开始计算利润率
 */
export function startCalc(): API.Res<string> {
    return goodsRequest.post('/partnerSpu/shopLink/startCalc')
}

/**
 * 查询利润率计算任务状态
 */
export function queryTask1(): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/partnerSpu/shopLink/queryTask')
}

/**
 * 查询商家的店铺链接利润计算信息
 */
export function queryCompanyCalcInfo(): API.Res<ProfitCalcInfoVo> {
    return goodsRequest.get('/partnerSpu/shopLink/queryCompanyCalcInfo')
}

/**
 * 查询利润率统计
 */
export function queryProfitStatistics(params): API.Res<ShopLinkProfitStatisticsResult> {
    return goodsRequest.get('/partnerSpu/shopLink/queryProfitStatistics', { params })
}

/**
 * 列表查询
 */
export function queryList(data: ShopLinkQueryParam): API.Res<ShopLinkQueryResult> {
    return goodsRequest.post('/partnerSpu/shopLink/queryList', { data })
}

/**
 * 查询导出进度
 */
export function queryExportData1(params: QueryExportData1Params): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/partnerSpu/shopLink/queryExportData', { params })
}

/**
 * 保存低利润率配置
 */
export function saveLowProfitConfig(data: ProfitConfigVo): API.Res<Object> {
    return goodsRequest.post('/partnerSpu/shopLink/saveLowProfitConfig', { data })
}

/**
 * 根据分销商品店铺链接修改线上价格
 */
export function updateOnlinePriceByPartnerSpuShopLink(data: SelectedUpdateOnlinePriceVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateOnlinePriceByPartnerSpuShopLink', { data })
}

/**
 * 根据分销商品店铺链接全量修改线上价格
 */
export function updateOnlinePriceByAllPartnerSpuShopLink(data: AllShopLinkUpdateOnlinePriceVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateOnlinePriceByAllPartnerSpuShopLink', { data })
}

/**
 * 查询商品分销链路
 */
export function queryGoodsDistributionHierarchy(
    data: SupplierDrpGoodsReturnGoodsAddressVo[]
): API.Res<Record<string, AfterSaleAddressSupplierHierarchyVo[]>> {
    return goodsRequest.post('/goodsQuery/queryGoodsDistributionHierarchyV2', { data })
}

/**
 * undefined
 */
export function querySimpleSpuList(data: QuerySimpleSpuListParam): API.Res<SimpleSpuInfoVo> {
    return goodsRequest.post('/addressstrategy/querySimpleSpuList', { data })
}
